import { render, staticRenderFns } from "./infoEn.vue?vue&type=template&id=124cfcd8&scoped=true&"
import script from "./infoEn.vue?vue&type=script&lang=js&"
export * from "./infoEn.vue?vue&type=script&lang=js&"
import style0 from "./infoEn.vue?vue&type=style&index=0&id=124cfcd8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124cfcd8",
  null
  
)

export default component.exports